import AccountChangePasswordForm from "../../components/account/AccountChangePasswordForm.tsx";
import UtilsHelper from "../../helpers/utilsHelper.ts";
import AccountLayout from "../../components/layouts/AccountLayout.tsx";

const AccountChangePasswordPage = () => {
    UtilsHelper.changeWindowDocumentTitle("Zmiana hasła");
    return (
        <AccountLayout>
            <div className={"bg-neutral-900 p-6 md:p-10 max-w-lg shadow-3xl rounded-3xl"}>
                <AccountChangePasswordForm/>
            </div>
        </AccountLayout>
    );
};

export default AccountChangePasswordPage;